import { parseState } from '@sky-distribution/gp-onboarding-shared-utils';
import { maskObject } from '@sky-distribution/mask-util';
import { MaskObject } from '@sky-distribution/mask-util/lib/type';

export const getDebugData = (): Record<string, unknown> => {
  const state = parseState();

  return {
    actions: state?.actions,
    context: {
      ids: (state?.context as Record<string, unknown>)?.ids,
      submission: maskObject(
        (state?.context as Record<string, unknown>)?.submission as MaskObject,
      ),
    },
  };
};
